<template>
    <div :class="$style.container" id="tutorBarContainer">
        <ul :class="$style.top">
            <li v-for="(item, index) in tags" :key="item"
                :class="index === (tags.length -1) ? $style.active: ''"
            >{{item}}
                <i :class="['iconfont', 'icon-rightarrow2f', $style.arrow]"
                   v-if="index < (tags.length -1)"
                ></i>
            </li>
        </ul>
        <h4 :class="$style.title">
            <p :class="$style.name" v-text="association"></p>
            <div style="margin-bottom: 10px">
                <el-button class="el-icon-plus" type="success" @click.stop="handleAdd" v-if="btnAdd" size="small"
                           :disabled="disabled">
                    新增</el-button>
                <el-button type="success" @click.stop="handleSuccess" v-if="btnSuccess"
                           size="small"
                           :disabled="disabled">
                   完成</el-button>
                <el-button :type="cusApproval" @click.stop="handleApprovalClick" v-if="btnApproval" size="small" :disabled="disabled">审批</el-button>
                <el-button :type="cusRecall" @click.stop="handleRecallClick" v-if="btnRecall" size="small" :disabled="disabled">撤回</el-button>
                <el-button type="success" @click.stop="handleAgreeClick" v-if="btnAgree" size="small" :disabled="disabled" class="icon">
                    <i :class="['iconfont', 'el-icon-success', $style.back]" style="position: relative;top:1px"></i>
                    同意</el-button>
                <el-button type="danger" @click.stop="handleRefuseClick" v-if="btnRefuse" size="small" :disabled="disabled"  class="icon">
                    <i :class="['iconfont', 'el-icon-error', $style.back]" style="position: relative;top:1px"></i>
                    拒绝</el-button>
                <el-button :type="cusSubmit" @click.stop="handleSubmitClick" v-if="btnSubmit" size="small" :disabled="disabled"  class="icon">
                    <i :class="['iconfont', 'el-icon-s-promotion', $style.back]" style="position: relative;top:1px"></i>
                    提交</el-button>
                <el-button type="danger" @click.stop="handleRepealClick" v-if="btnRepeal" size="small" :disabled="disabled">撤销</el-button>
                <el-button type="warning" @click.stop="handleCalculateDataClick" v-if="btnCalculateData" size="small" :disabled="disabled">重新计算统计数据</el-button>
                <el-button :type="cusSave" @click.stop="handleSaveClick" v-if="btnSave" size="small" :disabled="disabled">保存</el-button>
                <el-button type="danger" @click.stop="handleDeleteClick" v-if="btnDelete" size="small" id="delete_tutor"
                           :disabled="disabled">删除</el-button>
                <el-button type="success" @click.stop="handleAddClick" v-if="btnAdd" size="small" class="icon">
                    <i :class="['iconfont', 'el-icon-plus', $style.back]" style="position: relative;top:1px"></i>
                    新增</el-button>
                <el-button type="danger" @click.stop="handleBackClick" v-if="btnBack" size="small" style="margin-left: 30px" class="icon">
                    <i :class="['iconfont', 'icon-back', $style.back]" style="position: relative;top:1px"></i>
                    返回</el-button>
            </div>
        </h4>
        <div :class="$style.box">
            <p style="color: #87909A;font-size: 14px;margin-bottom: 10px;margin-top: 0;">协访人：{{associationName}}</p>
            <div :class="$style.boxContent">
                <p :class="$style.level" style="">{{associationDateStr}}</p>
                <p :class="$style.level" :style="{'color': textIndeedColor}">{{textIndeed}}</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            tags: {
                type: Array,
                default: () => []
            },
            title: {
                type: String,
                default: ''
            },
            subTitle: {
                type: String,
                default: ''
            },
            association: {
                type: String,
                default: ''
            },
            associationName: {
                type: String,
                default: ''
            },
            associationDateStr: {
                type: String,
                default: ''
            },
            textIndeed: {
                type: String,
                default: ''
            },
            cusApproval: {
                type: String,
                default: 'info'
            },
            cusSubmit: {
                type: String,
                default: 'warning'
            },
            cusRecall: {
                type: String,
                default: 'info'
            },
            cusSave: {
                type: String,
                default: 'primary'
            },
            btnSubmit: {
                type: Boolean,
                default: false
            },
            btnApproval: {
                type: Boolean,
                default: false
            },
            btnRecall: {
                type: Boolean,
                default: false
            },
            btnAgree: {
                type: Boolean,
                default: false
            },
            btnRefuse: {
                type: Boolean,
                default: false
            },
            btnRepeal: {
                type: Boolean,
                default: false
            },
            btnSave: {
                type: Boolean,
                default: false
            },
            btnDelete: {
                type: Boolean,
                default: false
            },
            btnBack: {
                type: Boolean,
                default: false
            },
            btnAdd: {
                type: Boolean,
                default: false
            },
            btnSuccess: {
                type: Boolean,
                default: false
            },
            btnCalculateData: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                defalut: false
            }
        },
        data(){
          return {
              textIndeedColor :''
          }
        },
        watch:{
            textIndeed:function (n,c) {
                if (n === "计划已确认"){
                    this.textIndeedColor = '#7ED321'
                } else if (n === "计划未提交") {
                    this.textIndeedColor = '#d31100'
                }else if (n === "计划待确认") {
                    this.textIndeedColor = '#FF9901'
                }
            }
        },
        methods: {
            handleSubmitClick () {
                this.$emit('btnSubmitClick')
            },
            handleApprovalClick () {
                this.$emit('btnApprovalClick')
            },
            handleRecallClick () {
                this.$emit('btnRecallClick')
            },
            handleAgreeClick () {
                this.$emit('btnAgreeClick')
            },
            handleRefuseClick () {
                this.$emit('btnRefuseClick')
            },
            handleRepealClick () {
                this.$emit('btnRepealClick')
            },
            handleSaveClick () {
                this.$emit('btnSaveClick')
            },
            handleDeleteClick () {
                this.$emit('btnDeleteClick')
            },
            handleCalculateDataClick () {
                this.$emit('btnCalculateDataClick')
            },
            handleBackClick () {
                this.$emit('btnBackClick')
            },
            handleAddClick (){
                this.$emit('btnAddClick')
            },
            handleSuccess (){
                this.$emit('btnSuccess')
            }
        },
        updated() {

        }
    }
</script>
<style lang="scss" module>
    @import '../assets/css/default';
    .container {
        .top {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            li {
                color:#000000;
                text-align:left;
                font-size: $TopTitleFontSize;
                .arrow {
                    font-size: $TopTitleFontSize;
                    color: #babac2;
                    vertical-align: bottom;
                }
            }
            .active {
                color: #59a8f9;
            }
        }
        .title {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            font-size:$TopSubFontSize;
            color:#000000;
            text-align:left;
            margin: 0px 0px;
            /*border-bottom:2px dotted #e7eaec;*/
            .name {
                color: #3b99f7;
                display: inline-block;
                font-size: 20px;
                margin-top: 20px;
            }
            .back {
                color: #fff;
                font-size: 16px;
            }
        }
        .box{
            /*display: flex;*/
            /*flex-direction: row;*/
            /*flex-wrap: nowrap;*/
            /*justify-content: space-between;*/
            /*align-items: center;*/
            font-size:$TopSubFontSize;
            color:#000000;
            text-align:left;
            margin: 10px 0px;
            margin-top: 0;
            border-bottom:2px dotted #e7eaec;
            .boxContent{
                display: flex;
                justify-content: space-between;
                .level{
                    color: #7ED321;
                    font-size: 14px;
                    margin-bottom: 10px;
                    margin-top: 0;
                    .site{
                        color: #87909A;
                        padding-left: 20px;
                    }
                    .clientele{
                        color: #FF9901;
                    }
                }
            }
            .dataStatus{
                font-size: 16px;
                color: #87909A;
                margin-bottom: 10px;
                margin-top: 5px;
                .clientele{
                    color: #FF9901;
                    padding: 0 10px;
                }
                .clientele2{
                    color: #ED3B3F;
                    padding: 0 10px;

                }
            }

        }
    }
</style>
<style scoped>
    #tutorBarContainer >>> .el-button--warning {
        color: #FFF;
        background-color: #FF9901;
        border-color: #FF9901;
    }
    #tutorBarContainer >>> .el-button--warning:hover {
        background: #ebb563;
        border-color: #ebb563;
        color: #FFF;
    }
    #delete_tutor{
        color: #FFF;
        background-color: #ED3B3F;
        border-color: #ED3B3F;
    }
    #delete_tutor:hover{
        color: #FFF;
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
    .el-button{
        font-size: 13px;
    }
    .el-button--small {
        padding: 9px 12px;
    }
    .icon {
        height: 33px;
        position: relative;
        top: 1px;
        padding: 7px 12px;
    }
    .icon >>> span{
        position: relative;
        top: -1px;
    }
</style>






// WEBPACK FOOTER //
// src/components/tutorBar.vue